export default __webpack_public_path__ + "static/media/home-bag.f1fd2948.gif";